export const ACE_MAXIMUM_DEPOSIT_LIMIT = 1_000_000
